<template>
  <div>
    <div class="leader-container">
      <div class="confirm-btn" @click="confirmCheck">通过</div>
      <div class="cancel-btn" @click="show_cancel = !show_cancel">未通过</div>
    </div>
    <!-- 未通过弹窗 -->
    <div class="mask" v-if="show_cancel" @click="show_cancel = !show_cancel"></div>
    <div class="cancel-window" v-if="show_cancel">
      <textarea placeholder="请输入未通过修改意见" v-model="advice"></textarea>
      <div class="btn-container">
        <div class="confirm-btn" @click="cancelCheck">未通过</div>
        <div class="cancel-btn" @click="show_cancel = !show_cancel">取消</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Leader",
  props: {},
  inject: ['app'],
  data: function () {
    return {
      show_cancel:false,
      advice:''
    };
  },
  mounted() {
  },
  methods: {
    confirmCheck() {
      console.log('confirmCheck')
      this.$emit('confirmCheck');
    },
    cancelCheck(){
      console.log('cancelCheck')
      // if(!this.advice) return this.$dialog.error('请输入修改意见');//是否必填
      this.$emit('cancelCheck',this.advice);
      this.show_cancel = !this.show_cancel
    }
  }
};
</script>
<style lang="scss" scoped>
.leader-container {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .confirm-btn,
  .cancel-btn {
    line-height: .9rem;
    text-align: center;
    flex: 1;
    font-size: .28rem;
  }

  .confirm-btn {
    background-color: #F64272;
    color: #fff;
  }

  .cancel-btn {
    background-color: #f7f7f7;
    color: #000;
  }
}

.cancel-window {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: .3rem;
  z-index: 556;
  background-color: #fff;

  textarea {
    height: 1rem;
    border-radius: .3rem;
    border: 1px solid #F64272;
    width: 100%;
    height: 2rem;
    padding: .2rem;
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: .3rem;

    .confirm-btn,
    .cancel-btn {
      line-height: .9rem;
      text-align: center;
      font-size: .28rem;
      border-radius: .9rem;
      width: 48%;
    }

    .confirm-btn {
      background-color: #F64272;
      color: #fff;
    }

    .cancel-btn {
      background-color: #f7f7f7;
      color: #000;
    }
  }
}
</style>
